import React, { useState, useRef, useContext, useEffect } from 'react';
import { StoreContext } from '../context/store-context';

const Quantity = ({ product, noUpdate = false }) => {
  const { checkout, updateLineItem } = useContext(StoreContext);
  const [quantity, setQuantity] = useState(product.quantity || 1);
  const [loading, setLoading] = useState(false)
  const quantityEl = useRef(null);

  const inputName = `quantity_${product.id}`;

  const updateQuantity = (e, quantity, blur = false) => {
    e.preventDefault();

    if(quantity < 1) { quantity = 1; }

    // If the quantity wasn't changed, forgeddaboutit
    if( !noUpdate && quantity === product.quantity ) { return false }

    // Set the new quantity to the new value, or a blank string if no value
    setQuantity(quantity || '')

    // Commit to updating the quantity if the new value is valid
    if(!noUpdate && quantity > 0) {
      setLoading(true)
      updateLineItem(checkout.id, product.id, quantity)
      return true;
    }

    // If leaving focus, set the input back to its original value
    if(blur) {
      setQuantity(product.quantity)
    }
  }

  useEffect(() => {
    if(!noUpdate) {
      setLoading(false)
    }
  }, [checkout, noUpdate])

  return (
    <div className="Quantity">
      <label
        htmlFor={inputName}
        className="ScreenReader"
        hidden
      >
        Quantity
      </label>
      <button
        className="Quantity__button Quantity__button--less notbutton"
        arial-label="Decrease quantity"
        onClick={(e) => {updateQuantity(e, parseInt(quantityEl.current.value) - 1)}}
        disabled={loading}
      >
        -
      </button>
      <input
        type="text"
        inputMode='numeric'
        name="quantity"
        id={inputName}
        ref={quantityEl}
        min="1"
        step="1"
        value={quantity}
        onChange={(e) => {updateQuantity(e, parseInt(quantityEl.current.value))}}
        onBlur={(e) => {updateQuantity(e, parseInt(quantityEl.current.value), true)}}
        className="Quantity__input"
        disabled={loading}
      />
      <button
        className="Quantity__button Quantity__button--more notbutton"
        arial-label="Increase quantity"
        onClick={(e) => {updateQuantity(e, parseInt(quantityEl.current.value) + 1)}}
        disabled={loading}
      >
        +
      </button>
    </div>
  )
}

export default Quantity;
